<template>
    <div
        :class="['replies_outer', depth === 0 ? 'indent' : '']"
        :data-depth="depth"
    >
        <div class="c-comments__comment">
            <img
                class="c-comments__img"
                :src="reply.user_avatar"
                :alt="reply.user_name + ' comment'"
            >
            <div class="c-comments__content">
                <div class="c-comments__user">
                    <p>
                        <a :href="'/u/' + reply.user_name">{{
                            reply.user_name
                        }}</a>
                    </p>
                    <p>
                        {{ parent_username ? parent_username : first_username }}
                    </p>
                    <p>{{ reply.comment_created }}</p>
                </div>
                <p
                    class="u-m-t1 u-m-b1 c-comments__text"
                    v-html="reply.comment_text"
                ></p>
                <p class="u-m-t1 u-m-b3" v-if="reply.comment_image != ''">
                    <img
                        :src="reply.comment_image"
                        :alt="reply.user_name + 'comment'"
                    >
                </p>
                <div class="c-comments__cta">
                    <p><a href="#" @click.prevent="commentReply">Reply</a></p>
                    <div @click="saveCommentLike(reply.comment_id)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="21"
                            viewBox="0 0 24 21"
                            fill="none"
                            :class="{ liked: userLiked > 0 }"
                        >
                            <path
                                d="M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <p>{{ commentLikes }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showReplyBox">
            <comment-box :parent-id="reply.comment_id"></comment-box>
        </div>
        <deep-replies
            v-for="deepReply in reply.replies"
            :key="deepReply.comment_id"
            :reply="deepReply"
            :first_username="deepReply.user_name"
            :depth="currentDepth"
        ></deep-replies>
    </div>
</template>

<script>
import CommentBox from "./CommentBox";

export default {
    name: "deepReplies",
    components: {
        CommentBox,
    },
    props: {
        reply: Object,
        first_username: String,
        depth: Number,
    },
    data() {
        return {
            userLiked: this.reply.user_liked,
            commentLikes: parseInt(this.reply.comment_likes) || 0,
            parent_username: this.reply.user_name,
            showReplyBox: false,
            currentDepth: this.depth + 1,
        };
    },
    mounted() {
        //console.log('reply', this.reply);
    },
    methods: {
        saveCommentLike(commentId) {
            let commentData = {
                commentId: commentId,
                communityId: this.$root.community.id,
            };
            this.$http.post('/post/like-comment', commentData).then(
                (response) => {
                    if (response.data.community_id === false) {
                        let modalData = {
                            cta: false,
                            message:
                                "You are currently not a member of this community - please join the community to like this comment",
                            communityName: this.$root.community.name,
                            communityThumbnail: this.$root.community.thumbnail,
                            title: "Join " + this.$root.community.name,
                        };
                        this.$root.$emit("bus-show-community-modal", modalData);
                    } else if (response.data.liked === true) {
                        this.commentLikes++;
                        this.userLiked = true;
                    } else if (response.data.liked === false) {
                        this.commentLikes--;
                        this.userLiked = false;
                    }
                },
                (response) => {
                    console.log("Errored:");
                    console.log(response);
                }
            );
        },
        commentReply() {
            this.showReplyBox = true;
        },
    },
};
</script>
